import "../../resources/css/common/combo_box_style.css";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";


export const ComboBox = (props) => {
    const {
        id,
        className,
        getOptionLabel,
        getOptionSelected,
        options,
        renderInput,
        renderOption,
        onChange,
        onInputChange,
        onChangeTextFiled,
        onSelect,
        disabled,
        value,
        defaultValue,
        freeSolo,
        autoSelect,
        disableClearable
    } = props;

    const renderInputBase = (params) => <TextField {...params} onChange={onChangeTextFiled} InputProps={{...params.InputProps, disableUnderline: true}} />;

    return (
        <Autocomplete
            id={id}
            className={`${className} combo-box`}
            options={options}
            getOptionLabel={getOptionLabel}
            getOptionSelected={getOptionSelected}
            renderInput={renderInput ?? renderInputBase}
            renderOption={renderOption}
            onChange={onChange}
            onInputChange={onInputChange}
            disabled={disabled}
            value={value}
            defaultValue={defaultValue}
            onSelect={onSelect}
            freeSolo={freeSolo}
            autoSelect={autoSelect}
            disableClearable={disableClearable}
        />
    );
};
